import { Injectable } from "@angular/core";
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { ToastController } from "@ionic/angular";
import { firstValueFrom } from "rxjs";

export interface EmailBody {
  adminEmailsTo: string[];
  subject: string;
  header: string;
  message?: string;
  html?: string;
  attachments?: any[];
}

@Injectable({
  providedIn: "root",
})
export class NotificationsService {
  /* Functions directions */
  API_SEND_INTERNAL_EMAIL = 'api2/notifications/sendInternalEmail';

  constructor(
    private functions: Functions,
    private toastController: ToastController
  ) {
  }

  public async sendInternalEmail(email: EmailBody = null) {
    const sendEmail = httpsCallableData(this.functions, this.API_SEND_INTERNAL_EMAIL);
    await firstValueFrom(sendEmail(email));
  }

  public async showToast(message: string, color?: string, icon?: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color || "dark",
      icon: icon || "checkmark-circle-outline",
    });
    toast.present();
  }
}
